import React, { useState } from 'react';
import { Alert, Divider } from 'antd';
export default () => {
  let [isOpen, setIsOpen] = useState(true);
  return <div>
      <Alert type="warning" onClose={() => setIsOpen(false)} showIcon closable description={'This report will be published after QA. Please save report submissions as draft.'} />
      {isOpen && <Divider />}
    </div>;
};